<template>
    <info-screen
            :title="$ml.get('errorPageTitle')"
            :text="text"
            :action="nextScreen"
            :button-text="$ml.get('errorPageButtonStartAgain')"
            :headerImg="3"
            :titleH1="true"
            :hideButton="this.callbackUrl.length === 0"
    >
    </info-screen>
</template>

<script>
    import InfoScreen from "../components/layout/info-screen";
    import Profile from '../helpers/profile'

    export default {
        name: "errorPage",
        components: {InfoScreen},
        data() {
            return {
                code: parseInt(this.$route.params.id) || 404,
                callbackUrl: document.querySelector('meta[name="callbackUrl"]').content,
            }
        },
        created() {
        },
        computed: {
            text: function () {
                switch (this.code) {
                    case 404: return this.$ml.get('errorPageText404');
                    case 405: return this.$ml.get('errorUserNotAllowed');
                    case 419: return this.$ml.get('error419CSRF');
                    case 444: return this.$ml.get('errorAuthClient');
                    case 445: return this.$ml.get('errorOldBrowser');
                    default: return this.$ml.get('errorServiceIsBroken');
                }

            }
        },

        methods: {
            nextScreen: function () {
                window.location = this.callbackUrl + '?error=' + this.code;
            },
        }

    }
</script>

<style lang="scss" scoped>

</style>